export const heroStats = [
  { id: "s1", value: "4", label: "常见版本类型" },
  { id: "s2", value: "9", label: "内容分区" },
  { id: "s3", value: "8", label: "常见问题" },
];

export const overviewFacts = [
  {
    id: "f1",
    icon: "ri-film-line",
    title: "主题定位",
    desc: "围绕“姐姐的朋友电影”整理完整版、未删减与高清资源相关的信息，帮助浏览者在观看前先弄清楚各类说法的含义。",
  },
  {
    id: "f2",
    icon: "ri-stack-line",
    title: "常见版本",
    desc: "检索中经常遇到完整版、未删减版、无删减版与高清完整版四种标签，它们分别指向内容长度、删减情况与画面质量。",
  },
  {
    id: "f3",
    icon: "ri-compass-3-line",
    title: "内容方向",
    desc: "页面从剧情结构、版本差异、画质字幕与查询方向四条线索展开，让关键词背后的问题一次看清。",
  },
  {
    id: "f4",
    icon: "ri-user-heart-line",
    title: "适合人群",
    desc: "适合希望先了解影片大致内容、版本差异与观看注意事项，再决定是否继续查找的普通浏览者。",
  },
];

export const coreContents = [
  {
    id: "c1",
    icon: "ri-book-open-line",
    no: "01",
    title: "完整剧情走向",
    desc: "完整版通常会保留公映版中被省略的过渡情节，让故事的时间线索与人物动机衔接得更自然，前后因果也更清楚。",
  },
  {
    id: "c2",
    icon: "ri-scissors-cut-line",
    no: "02",
    title: "未删减片段",
    desc: "所谓未删减，多指恢复了送审或发行时被剪掉的部分，这些片段往往承担铺垫情绪的用途，删去后段落会显得跳脱。",
  },
  {
    id: "c3",
    icon: "ri-movie-2-line",
    no: "03",
    title: "完整片头片尾",
    desc: "完整发行版本一般保留原始开场字幕、制作名单与片尾画面，而精简版有时会把片头片尾直接裁掉以缩短时长。",
  },
  {
    id: "c4",
    icon: "ri-translate-2",
    no: "04",
    title: "字幕与音轨",
    desc: "较完整的资源往往附带多语言字幕与原声、配音音轨，字幕的断句与时间轴是否对齐，也直接影响观看体验。",
  },
  {
    id: "c5",
    icon: "ri-clapperboard-line",
    no: "05",
    title: "幕后与附加内容",
    desc: "部分完整版会收录拍摄花絮、角色设定或制作访谈等附加素材，它们不是剧情本身，但能补充影片的背景信息。",
  },
  {
    id: "c6",
    icon: "ri-time-line",
    no: "06",
    title: "时长与章节结构",
    desc: "完整版的时长通常长于公映版，章节划分也更细，通过时长与段落数量可以初步判断一个版本是否相对完整。",
  },
];

export const versionTabs = [
  {
    id: "full",
    label: "完整版",
    subtitle: "以时长与内容结构为判断标准",
    summary:
      "“完整版”强调的是内容结构相对齐全，而不是单指画质。判断一个版本是否称得上完整，通常要同时看总时长、段落是否衔接连贯、片头片尾是否保留。",
    features: [
      "时长通常长于公映版或精简版",
      "保留更多过渡与铺垫段落",
      "片头片尾、制作名单相对完整",
    ],
    note: "常见误区：把“完整版”直接等同于“高清”，其实两者分别描述内容长度与画面质量。",
  },
  {
    id: "uncut",
    label: "未删减版",
    subtitle: "强调删减行为的反转",
    summary:
      "“未删减”是从删减的角度命名的，意味着相较发行版本恢复了被剪掉的片段。它更关注“少了什么又补回了什么”，而不是整体结构。",
    features: [
      "恢复送审或发行时删除的片段",
      "部分段落节奏会比精简版更舒缓",
      "不同发行地区删减范围可能不同",
    ],
    note: "常见误区：未删减不等于画质更好，也未必代表时长最长，需结合具体发行说明判断。",
  },
  {
    id: "uncensored",
    label: "无删减版",
    subtitle: "与未删减相近的检索说法",
    summary:
      "“无删减版”在多数语境下与“未删减版”含义接近，是同一类需求的另一种叫法。二者都指向“内容没有被剪掉”，检索时可作为同义方向理解。",
    features: [
      "与未删减版含义基本一致",
      "多作为检索关键词出现",
      "同样以片段是否保留为准",
    ],
    note: "常见误区：把“无删减”当成独立的第三种版本，实际上它多半只是表述差异。",
  },
  {
    id: "hd",
    label: "高清完整版",
    subtitle: "从画质维度描述完整内容",
    summary:
      "“高清完整版”把画质与内容两个维度合在一起描述：既希望内容完整，也要求画面清晰。画质取决于分辨率与编码，内容取决于版本，两者要分开看。",
    features: [
      "关注分辨率与画面码率",
      "常与完整、无删减标签同时出现",
      "字幕与音轨清晰度同样影响观感",
    ],
    note: "常见误区：标签写着高清，实际分辨率可能并不高，应以实际参数为准。",
  },
];

export const qualityPoints = [
  {
    id: "q1",
    icon: "ri-hd-line",
    title: "分辨率与画面比例",
    desc: "常见清晰度从标清到全高清不等，画面比例是否与原始版本一致，决定了观看时会不会出现黑边或拉伸。",
  },
  {
    id: "q2",
    icon: "ri-speed-line",
    title: "码率与画面稳定度",
    desc: "同样标注高清的两个文件，码率不同观感差距可能很大。码率偏低时快速运动画面容易出现色块与模糊。",
  },
  {
    id: "q3",
    icon: "ri-file-text-line",
    title: "字幕时间轴对齐",
    desc: "字幕与音轨是否对齐，是判断资源是否用心整理的重要细节。时间轴错位会让内容理解大打折扣。",
  },
  {
    id: "q4",
    icon: "ri-volume-up-line",
    title: "音轨与配音选择",
    desc: "原声与配音各有取舍，音轨完整度同样属于观看体验的一部分，音量忽大忽小往往说明音源经过多次转码。",
  },
];

export const structurePoints = [
  {
    id: "st1",
    no: "一",
    title: "开场铺垫",
    desc: "影片开头通常用较长的篇幅交代人物关系与情境，这部分在精简版本里容易被压缩，却对理解后续发展很关键。",
  },
  {
    id: "st2",
    no: "二",
    title: "人物关系推进",
    desc: "人物之间的互动与情绪变化构成叙事主线，完整版会保留更多日常细节，让关系的变化显得更有层次。",
  },
  {
    id: "st3",
    no: "三",
    title: "节奏与情绪段落",
    desc: "中段往往是节奏调整的部分，交代动机、缓和冲突，被删减后容易显得突兀，是判断完整度的一个观察点。",
  },
  {
    id: "st4",
    no: "四",
    title: "收束与片尾",
    desc: "结尾如何处理人物去向，会直接影响整体观感。完整片尾往往包含情绪落点与制作信息，不宜跳过。",
  },
];

export const faqItems = [
  {
    id: "faq1",
    category: "版本差异",
    q: "完整版和未删减版是同一个意思吗？",
    a: "不是完全等同。完整版侧重内容结构齐全、段落衔接连贯；未删减版侧重说明片段有没有被剪掉。两者经常同时出现，但描述的角度不同，判断时最好分别看时长与片段保留情况。",
  },
  {
    id: "faq2",
    category: "版本差异",
    q: "无删减版与未删减版有什么区别？",
    a: "在多数语境下两者含义基本相同，都属于“内容没有被剪掉”的说法，只是表述习惯不同。检索时可以把它们当作同一方向来理解，不必认为存在两种完全独立的版本。",
  },
  {
    id: "faq3",
    category: "版本差异",
    q: "完整版一般会比公映版多出哪些内容？",
    a: "通常是过渡情节、铺垫段落、片头片尾与部分被剪掉的片段。这些内容不一定改变主线，但会让情境交代和人物动机更自然，因此完整版整体上显得更连贯。",
  },
  {
    id: "faq4",
    category: "版本差异",
    q: "为什么同一部影片会出现多个时长不同的版本？",
    a: "不同发行地区、不同渠道与不同年份的版本，删减标准和时间长度往往不一样，于是就会出现时长不同的多个版本。看到时长不一致时，先确认它对应的发行说明会更稳妥。",
  },
  {
    id: "faq5",
    category: "画质字幕",
    q: "高清完整版指的就是画质更好的完整版吗？",
    a: "可以说方向接近。高清描述的是画面清晰度，完整描述的是内容长度，两者合在一起表示既想内容齐全、又希望画面清晰。但标签不等于实际参数，仍需以分辨率等信息为准。",
  },
  {
    id: "faq6",
    category: "画质字幕",
    q: "字幕或配音会影响对完整版内容的判断吗？",
    a: "会有影响。字幕时间轴错位或多条字幕混用，容易让人误以为内容有缺失或重复。观看前先确认字幕与音轨是否对齐，能减少很多误解。",
  },
  {
    id: "faq7",
    category: "资源说明",
    q: "完整资源通常包含哪些文件或信息？",
    a: "一般包括视频文件本体、字幕文件以及必要的说明。是否附带字幕、说明是否清晰、参数是否标注完整，都可以作为判断整理是否规范的参考，但具体内容因来源而异。",
  },
  {
    id: "faq8",
    category: "资源说明",
    q: "浏览完整版内容时需要注意哪些版权问题？",
    a: "影视作品通常受版权保护，建议通过正规、获得授权的渠道观看。本站只做信息整理与名词解释，不提供影片文件，也不引导绕过授权的观看方式。",
  },
];

export const faqCategories = ["全部", "版本差异", "画质字幕", "资源说明"];

export const guideTips = [
  {
    id: "g1",
    icon: "ri-shield-check-line",
    title: "优先选择正规渠道",
    desc: "有条件时优先通过获得授权的平台观看，既能保证画质，也能避免版权与安全风险。",
  },
  {
    id: "g2",
    icon: "ri-search-eye-line",
    title: "分辨“完整”标签",
    desc: "标签并不等于事实，结合时长、段落衔接与片头片尾是否保留，能更理性地判断版本完整度。",
  },
  {
    id: "g3",
    icon: "ri-lock-line",
    title: "留意文件安全",
    desc: "来源不明的文件可能携带风险，浏览时不要随意下载或运行不熟悉的程序，注意保护个人信息。",
  },
  {
    id: "g4",
    icon: "ri-heart-3-line",
    title: "尊重创作与版权",
    desc: "了解作品是为了更好地欣赏它，尊重创作者的劳动，才能让优质内容持续产出。",
  },
];

export const relatedTopics = [
  {
    id: "r1",
    title: "完整版与公映版的区别",
    desc: "从时长、段落与片头片尾三个角度，快速区分两类版本。",
    tag: "版本差异",
    img: "https://readdy.ai/api/search-image?query=warm%20abstract%20gradient%20background%20with%20film%20grain%20texture%20and%20golden%20bokeh%20light%20spots%2C%20cinematic%20editorial%20art%20style%2C%20soft%20shadows%2C%20rich%20amber%20and%20terracotta%20tones%2C%20minimal%20composition%2C%20high%20detail&width=600&height=400&seq=sister-friend-related-01&orientation=landscape",
  },
  {
    id: "r2",
    title: "高清完整版的画质标准",
    desc: "分辨率、码率与画面比例各自说明什么问题。",
    tag: "画质字幕",
    img: "https://readdy.ai/api/search-image?query=vintage%20cinema%20seats%20in%20a%20dark%20hall%20illuminated%20by%20warm%20amber%20light%2C%20moody%20atmospheric%20editorial%20photography%2C%20soft%20shadows%2C%20cozy%20retro%20feeling%2C%20rich%20warm%20tones%2C%20high%20detail&width=600&height=400&seq=sister-friend-related-02&orientation=landscape",
  },
  {
    id: "r3",
    title: "字幕与音轨的常见问题",
    desc: "时间轴错位、多字幕混用时该怎么处理。",
    tag: "画质字幕",
    img: "https://readdy.ai/api/search-image?query=stack%20of%20film%20cases%20and%20a%20vintage%20projector%20lens%20on%20a%20wooden%20table%20with%20warm%20golden%20lighting%2C%20cozy%20editorial%20still%20life%20photography%2C%20soft%20shadows%2C%20rich%20amber%20tones%2C%20high%20detail&width=600&height=400&seq=sister-friend-related-03&orientation=landscape",
  },
  {
    id: "r4",
    title: "查找资源时的注意事项",
    desc: "如何避开风险来源，理性对待“完整资源”这一说法。",
    tag: "资源说明",
    img: "https://readdy.ai/api/search-image?query=cozy%20evening%20scene%20with%20a%20television%20screen%20glow%20and%20a%20bowl%20of%20popcorn%20on%20a%20warm%20sofa%2C%20soft%20golden%20lamp%20light%2C%20editorial%20lifestyle%20photography%2C%20warm%20terracotta%20tones%2C%20inviting%20atmosphere%2C%20high%20detail&width=600&height=400&seq=sister-friend-related-04&orientation=landscape",
  },
];